export default __webpack_public_path__ + "static/media/eiffel-tower.f4a8366f.jpg";